const DEBUG = false;

export default function debug(...args: any) {
  const params = new URL(window.document.location.href).searchParams;
  if (params.get("__debug") !== "true" && (DEBUG as boolean) !== true) return;
  // eslint-disable-next-line
  console.debug(...args);
}
